import { render, staticRenderFns } from "./jxkyyqzjbhqkb.vue?vue&type=template&id=04a3700f&scoped=true"
import script from "./jxkyyqzjbhqkb.vue?vue&type=script&lang=js"
export * from "./jxkyyqzjbhqkb.vue?vue&type=script&lang=js"
import style0 from "./jxkyyqzjbhqkb.vue?vue&type=style&index=0&id=04a3700f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3700f",
  null
  
)

export default component.exports